import UilAngleDown from '@iconscout/react-unicons/icons/uil-angle-down';
import UilSignout from '@iconscout/react-unicons/icons/uil-signout';
import UilUser from '@iconscout/react-unicons/icons/uil-user';
import UilSync from '@iconscout/react-unicons/icons/uil-sync';
import { Avatar, Modal } from 'antd';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Popover } from '../../popup/popup';
import { logOut } from '../../../redux/authentication/actionCreator';
import { useAuth } from 'react-oidc-context';
import { useUser } from '../../../context/UserContext';
import Heading from '../../heading/heading';
import AccountIdentifier from '../../AccountIdentifier';
import Profile from './Profile';

const AuthInfo = React.memo(() => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userDetails } = useUser();
  const { user, removeUser, signoutRedirect, clearStaleState } = useAuth();
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);

  const toggleModal = () => {
    setShowModal((prev) => !prev);
    setPopoverVisible(false);
  };

  const handleSignOut = () => {
    dispatch(
      logOut(() => {
        // clear keycloak session
        removeUser();
        signoutRedirect({
          id_token_hint: user?.id_token,
          // post_logout_redirect_uri: 'http://localhost:3000/', // LOCAL
          // post_logout_redirect_uri: 'https://endow.sec.gov.ph/', // PROD
          post_logout_redirect_uri: 'https://dms.fortisph.space/', // DEV
          // post_logout_redirect_uri: 'https://dms-uat.sec.gov.ph/' // UAT
        });
        clearStaleState();
      }),
    );
  };

  const userName = user?.profile?.preferred_username;
  // const userRole = user?.profile?.role || 'Officer';
  const avatarUrl = user?.profile?.avatar || require('../../../static/img/avatar/profileImage.png');

  const userRole = localStorage.getItem('userRole');

  const userContent = (
    <div>
      <div className="min-w-[280px] sm:min-w-full pt-4">
        <figure className="flex items-center text-sm rounded-[8px] bg-section dark:bg-white10 py-[20px] px-[25px] mb-[12px]">
          <img className="ltr:mr-4 rtl:ml-4" src={avatarUrl} alt="User Avatar" />
          <figcaption>
            <Heading className="text-dark dark:text-white87 mb-0.5 text-sm" as="h5">
              {userName}
            </Heading>
            <p className="mb-0 text-xs text-body dark:text-white60">{userRole}</p>
          </figcaption>
        </figure>
        <ul className="mb-0">
          <li>
            <Link
              // to="#"
              // onClick={() => {
              //   setShowProfileModal(true);
              //   setPopoverVisible(false);
              // }}
              to={`/${userRole}/pages/profile`}
              className="inline-flex items-center hover:bg-shadow-transparent text-light dark:text-white60 dark:hover:text-white hover:text-primary dark:hover:bg-white10 dark:rounded-4 hover:pl-6 w-full px-2.5 py-3 text-sm transition-all ease-in-out delay-150"
            >
              <UilUser className="w-4 h-4 ltr:mr-3 rtl:ml-3" /> Profile
            </Link>
          </li>

          {/* <li>
            <Link
              to="#"
              onClick={toggleModal}
              className="inline-flex items-center hover:bg-shadow-transparent text-light dark:text-white60 dark:hover:text-white hover:text-primary dark:hover:bg-white10 dark:rounded-4 hover:pl-6 w-full px-2.5 py-3 text-sm transition-all ease-in-out delay-150"
            >
              <UilSync className="w-4 h-4 ltr:mr-3 rtl:ml-3" /> Switch Account
            </Link>
          </li> */}
        </ul>
        <Link
          to="#"
          onClick={handleSignOut}
          className="flex items-center justify-center text-sm font-medium bg-[#f4f5f7] dark:bg-[#32333f] h-[50px] text-light hover:text-primary dark:hover:text-white60 dark:text-white87 mx-[-15px] mb-[-15px] rounded-b-6"
        >
          <UilSignout className="w-4 h-4 ltr:mr-3 rtl:ml-3" /> Sign Out
        </Link>
      </div>
    </div>
  );

  return (
    <div className="flex items-center justify-end flex-auto">
      <div className="flex ltr:ml-3 rtl:mr-3 ltr:mr-4 rtl:ml-4 ssm:mr-0 ssm:rtl:ml-0">
        <Popover
          placement="bottomRight"
          content={userContent}
          action="click"
          visible={popoverVisible}
          onVisibleChange={setPopoverVisible}
        >
          <Link to="#" className="flex items-center text-light whitespace-nowrap">
            <Avatar src={avatarUrl} alt="User Avatar" />
            <span className="ltr:mr-1.5 rtl:ml-1.5 ltr:ml-2.5 rtl:mr-2.5 text-white dark:text-white60 text-sm font-medium md:hidden">
              {userName}
            </span>
            <UilAngleDown className="text-white w-4 h-4 ltr:md:ml-[5px] rtl:md:mr-[5px]" />
          </Link>
        </Popover>
        <Modal open={showModal} onCancel={toggleModal} width={800} footer={null}>
          <AccountIdentifier toggleClose={toggleModal} />
        </Modal>
      </div>

      <Profile
        open={showProfileModal}
        onClose={() => setShowProfileModal(false)}
        userData={userDetails}
      />
    </div>
  );
});

export default AuthInfo;
